import { gql } from '@apollo/client';

export const RATE_FIELDS = gql`
    fragment RateFields on rates {
        dimension_key
        dimensions
        label
        max
        min
        rate
        tariff_id
        type
        min2
        max2
        qbo_tag
        service_level_id
        subregion_id
    }
`;
